import { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    projectType: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Construct mailto link
    const subject = encodeURIComponent(`New Inquiry from ${formData.name} - ${formData.company}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\n` +
      `Company: ${formData.company}\n` +
      `Email: ${formData.email}\n` +
      `Project Type: ${formData.projectType}\n\n` +
      `Message:\n${formData.message}`
    );
    
    window.location.href = `mailto:management@khepry.com?subject=${subject}&body=${body}`;
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="space-y-6"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      data-testid="contact-form"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
            className="contact-input"
            data-testid="contact-name-input"
          />
        </div>
        <div>
          <input
            type="text"
            name="company"
            placeholder="Company"
            value={formData.company}
            onChange={handleChange}
            required
            className="contact-input"
            data-testid="contact-company-input"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            className="contact-input"
            data-testid="contact-email-input"
          />
        </div>
        <div>
          <select
            name="projectType"
            value={formData.projectType}
            onChange={handleChange}
            required
            className="contact-input"
            data-testid="contact-project-type-select"
          >
            <option value="" disabled>Type of Project</option>
            <option value="project-management">Strategic Project Management</option>
            <option value="cross-border">Cross-Border Structuring</option>
            <option value="real-estate">Real Estate Advisory</option>
            <option value="investment">Investment Structuring</option>
            <option value="partnerships">Strategic Partnerships</option>
            <option value="other">Other</option>
          </select>
        </div>
      </div>

      <div>
        <textarea
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          required
          className="contact-input contact-textarea"
          data-testid="contact-message-textarea"
        />
      </div>

      <div>
        <button
          type="submit"
          className="btn-primary w-full md:w-auto"
          data-testid="contact-submit-button"
        >
          <span>Send Message</span>
          <Send size={16} strokeWidth={1.5} />
        </button>
      </div>
    </motion.form>
  );
};

export default ContactForm;
